/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tv } from 'tailwind-variants';
import { withStandardComponentWrapper } from 'helpers/HOC';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import { parseStyleParams } from 'lib/utils/style-param-utils';
import { getCtaStyle } from 'lib/utils/cta-utils';
import { getTestProps } from 'lib/testing/utils';
import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import { createCTAClickGTMEvent } from 'lib/utils/gtm-utils';
import { RemixIcon } from 'helpers/RemixIcon';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const ServiceCardItem = (props)=>{
    const isEditing = useIsEditing();
    const { heading, description, cardLink, itemIcon } = props?.fields || {};
    const itemIconTitle = itemIcon?.fields?.title?.value;
    const { RenderingIdentifier } = props?.params || {};
    const styles = parseStyleParams(props.params, [
        'cta1',
        'cta2'
    ]);
    const { container, header, body, contentWrapper, content, heading: headingTV, description: descriptionTV, footer, buttonDivider, cta, iconFill } = TAILWIND_VARIANTS();
    return (
        // <div className="bg-red-500 w-full h-[100px]">Slide 1</div>
        /*#__PURE__*/ (_jsx("article", {
            className: container(),
            "data-component": "authorable/shared/lists/servicecarditem",
            ...editingHydrationProps(isEditing),
            id: RenderingIdentifier,
            ...getTestProps(`component-service-card-item-${props?.rendering?.uid}`),
            children: /*#__PURE__*/ _jsx("div", {
                className: body(),
                children: /*#__PURE__*/ _jsxs("div", {
                    className: contentWrapper(),
                    children: [
                        itemIconTitle && /*#__PURE__*/ _jsx("div", {
                            className: header(),
                            children: /*#__PURE__*/ _jsx(RemixIcon, {
                                name: itemIconTitle || 'information-line',
                                size: "xl",
                                "aria-hidden": !!heading?.value,
                                title: !heading?.value ? itemIcon?.displayName || 'Icon' : undefined,
                                className: iconFill()
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: content(),
                            children: [
                                /*#__PURE__*/ _jsx(PlainTextWrapper, {
                                    className: headingTV(),
                                    field: heading,
                                    ...getTestProps(`heading`),
                                    tag: "h3"
                                }),
                                /*#__PURE__*/ _jsx(PlainTextWrapper, {
                                    className: descriptionTV(),
                                    field: description,
                                    ...getTestProps(`description`),
                                    tag: "p"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: footer(),
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: buttonDivider()
                                }),
                                /*#__PURE__*/ _jsx(LinkWrapper, {
                                    ctaComponentClass: "component-card-item-button-1-color",
                                    className: cta(),
                                    ctaStyle: getCtaStyle(styles.cta1, 'tertiary'),
                                    field: cardLink,
                                    "aria-label": `Read more for ${heading?.value}`,
                                    ...getTestProps(`primary-cta`),
                                    gtmEvent: createCTAClickGTMEvent({
                                        header: heading?.value,
                                        ctaText: cardLink?.value?.text,
                                        ctaType: 'text link',
                                        componentName: 'Services Help Block',
                                        ctaLink: cardLink?.value?.href
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        }))
    );
};
export const Default = withStandardComponentWrapper(ServiceCardItem);
const TAILWIND_VARIANTS = tv({
    defaultVariants: {
        style: 'primary',
        colCount: '1'
    },
    slots: {
        container: [
            'flex',
            'flex-col',
            'flex-grow',
            'h-full',
            'overflow-hidden',
            'rounded-general-border-radius-card',
            'bg-component-card-item-surface',
            'shadow-[0_0_8px_0]',
            'shadow-color-black-alpha-10',
            'border-component-card-item-border-width',
            'border-solid',
            'border-transparent',
            'hover:border-color-core-color-4-SkyBlue',
            'focus:border-color-core-color-4-SkyBlue'
        ],
        header: [],
        body: [
            'flex',
            'flex-col',
            'flex-grow',
            'h-full',
            'w-full'
        ],
        contentWrapper: [
            'flex',
            'flex-col',
            'flex-grow',
            'w-full',
            'justify-between',
            'gap-component-video-card-portrait-content-button-margin-top',
            'p-component-card-item-landscape-content-padding-y',
            'text-left'
        ],
        content: [
            'flex',
            'flex-col',
            'w-full',
            'gap-spacing-spacing-24'
        ],
        heading: [
            'font-semibold',
            'font-typography-font-family-body',
            'text-typography-font-size-body-xlarge',
            'text-component-card-item-title',
            'leading-typography-line-height-body-xlarge'
        ],
        description: [
            'text-typography-font-size-body-medium',
            'text-component-card-item-body',
            'leading-typography-line-height-body-medium',
            'font-typography-font-weight-body',
            'font-typography-font-family-body'
        ],
        footer: [
            'flex',
            'flex-col',
            'gap-spacing-spacing-24',
            'w-full'
        ],
        buttonDivider: [
            'w-component-section-divider-width',
            'h-component-section-divider-height',
            'bg-component-section-divider'
        ],
        cta: [
            'justify-between',
            'leading-[125%]'
        ],
        iconFill: [
            'text-color-core-color-3-Coral'
        ]
    }
});
